<template>
  <svg
    width="216"
    height="163"
    viewBox="0 0 216 163"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M71.8252 94.4813L82.2366 88.5144L101.132 121.484C101.681 122.442 101.349 123.664 100.391 124.214L93.4498 128.191C92.4915 128.741 91.2694 128.409 90.7201 127.451L71.8252 94.4813Z"
      fill="#BBE2DA"
    />
    <path
      d="M56.1979 95.3693C55.6487 94.4109 55.9803 93.1888 56.9387 92.6396L60.4091 90.6506C61.3675 90.1014 62.5896 90.433 63.1388 91.3914L69.1056 101.803C69.6549 102.761 69.3232 103.983 68.3649 104.532L64.8944 106.521C63.9361 107.071 62.7139 106.739 62.1647 105.781L56.1979 95.3693Z"
      fill="#3F9784"
    />
    <rect
      x="128.21"
      y="54.0988"
      width="8"
      height="12"
      rx="4"
      transform="rotate(-29.8172 128.21 54.0988)"
      fill="#BBE2DA"
    />
    <path
      d="M58.7703 91.8134C57.3973 89.4175 58.2264 86.3622 60.6223 84.9891L84.0479 71.5638L96.7862 93.7905L73.3605 107.216C70.9647 108.589 67.9093 107.76 66.5363 105.364L58.7703 91.8134Z"
      fill="#BBE2DA"
    />
    <path
      d="M147.702 93.6412C147.702 93.6412 124.693 93.4813 109.949 93.3788C106.222 93.3529 100.913 93.928 95.0598 94.8005L82.3002 72.5365C86.0117 67.9277 89.1923 63.6384 91.0541 60.4094L109.913 27.7024L147.702 93.6412Z"
      fill="#76C6B5"
    />
    <rect
      x="107.336"
      y="25.7211"
      width="8"
      height="82"
      rx="4"
      transform="rotate(-29.8172 107.336 25.7211)"
      fill="#3F9784"
    />
    <path
      d="M77.7039 104.739L88.1153 98.7721L91.684 104.999L85.1718 104.697L77.7039 104.739Z"
      fill="#97D3C6"
    />
    <path
      d="M109.334 29.2098L146.252 93.6263L142.781 93.6037L138.741 93.5905L126.282 65.5768L109.334 29.2098Z"
      fill="#53B7A1"
    />
    <path
      d="M150.371 50.5017L151.925 45.2921L184.431 17.2514L193.613 32.8821L150.371 50.5017Z"
      fill="#BBE2DA"
    />
    <path
      d="M143.923 41.1483L143.146 38.7199L149.172 7.34815L160.278 12.1351L143.923 41.1483Z"
      fill="#BBE2DA"
    />
    <path
      d="M152.603 58.5207L154.501 60.2234L185.59 67.5688L185.769 55.4768L152.603 58.5207Z"
      fill="#BBE2DA"
    />
    <circle
      cx="133.32"
      cy="21.1389"
      r="2"
      transform="rotate(4.53136 133.32 21.1389)"
      fill="#97D3C6"
    />
    <circle
      cx="169.482"
      cy="71.1521"
      r="2"
      transform="rotate(4.53136 169.482 71.1521)"
      fill="#97D3C6"
    />
    <circle
      cx="170.393"
      cy="9.02988"
      r="3"
      transform="rotate(4.53136 170.393 9.02988)"
      fill="#97D3C6"
    />
    <circle
      cx="192.169"
      cy="44.3608"
      r="2.5"
      transform="rotate(4.53136 192.169 44.3608)"
      fill="#97D3C6"
    />
    <path
      d="M159 142.663C159 147.543 137.048 151.5 108.212 151.5C79.3761 151.5 56 147.543 56 142.663C56 137.782 67.3673 132.5 96.2032 132.5C125.039 132.5 159 135.667 159 142.663Z"
      fill="#E7E8E9"
    />
    <path
      d="M121.5 148.5C138.345 148.5 152 144.247 152 139C152 133.753 138.345 129.5 121.5 129.5C104.655 129.5 91 133.753 91 139C91 144.247 104.655 148.5 121.5 148.5Z"
      fill="#E7E8E9"
    />
  </svg>
</template>
